module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/vi/3-8695bcdf3424cdbd7b1762d46f9df5f8.jpg";